import usePrivateAxios from '@/common/api/usePrivateAxios'
import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.type'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

type UseMaintenanceWorkflowForwardingsDirectiveEntryKlasses = (
  workflowId: string | undefined,
) => UseQueryResult<MaintenanceForwardingsDirectiveEntryKlass[], unknown>

export const useMaintenanceWorkflowForwardingsDirectiveEntryKlasses: UseMaintenanceWorkflowForwardingsDirectiveEntryKlasses =
  (workflowId) => {
    const privateAxios = usePrivateAxios()

    return useQuery<
      { data: { data: MaintenanceForwardingsDirectiveEntryKlass[] } },
      unknown,
      MaintenanceForwardingsDirectiveEntryKlass[]
    >({
      enabled: !!workflowId,
      queryKey: ['maintenanceWorkflowForwardingsDirectiveEntryKlasses', workflowId],
      queryFn: () => privateAxios.get(`/maintenance/workflows/${workflowId}/forwardings_directive_entry_klasses`),
      select: (data) => data?.data?.data,
    })
  }
